<template>
  <div>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" clearable></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="filials"
      :search="search"
      :items-per-page.sync="itemPerPage"
      :page.sync="currentPage"
      class="transparent"
      :footer-props="foot_props"
      :no-data-text="$t('label.nodata')"
    >
      <template v-slot:top>
        <v-btn fab absolute bottom @click="edit({status:1})" dark class="pink">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.action="{item}">
        <v-btn icon @click="edit(item)">
          <v-icon color="primary">mdi-eye</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.admin="{item}">{{$store.getters['admin/posuser'](item.admin).description}}</template>
      <template v-slot:item.status="{item}">{{$t("status.rec_"+item.status)}}</template>
      <template v-slot:item.created="{item}">{{item.created | dt-time}}</template>
      <template v-slot:item.updated="{item}">{{item.updated | dt-time}}</template>
    </v-data-table>
    <v-dialog v-model="d_edit" persistent width="500">
      <v-card color="yellow lighten-5">
        <v-card-title>
          <span>{{$t("admin.filial")}}</span>
          <v-spacer></v-spacer>
          <v-btn @click="d_edit=false" icon color="error">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" lazy-validation>
            <v-text-field
              v-model="item.name"
              :error-messages="filial_errors"
              :label="$t('fields.name')"
              :rules="[v=>!!v||$t('error.required')]"
            ></v-text-field>
            <v-select
              v-model="item.admin"
              :items="$store.getters['admin/posusers']"
              item-text="name"
              item-value="idx"
              :label="$t('fields.admin')"
            ></v-select>
            <v-select v-model="item.status" :items="$t('statuses')" :label="$t('fields.status')"></v-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="d_confirm=true" color="primary">{{$t("button.delete")}}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="update" color="primary">{{$t("button.update")}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      v-model="d_confirm"
      :mode="dmode"
      @click:ok="remove"
    >{{$t("dialog.txt.delFilial")}}</ConfirmDialog>
  </div>
</template>

<script>
import commonmixin from "@/mixins/commonlist.js";

export default {
  name: "AdminFilials",
  mixins: [commonmixin],
  data() {
    return {
      item: {},
      d_edit: false,
      filial_errors: "",
      headers: [
        {
          text: this.$t("fields.action"),
          value: "action",
          sortable: false,
          align: "center",
        },
        { text: this.$t("fields.name"), value: "name" },
        { text: this.$t("fields.admin"), value: "admin" },
        { text: this.$t("fields.created"), value: "created", align: "center" },
        { text: this.$t("fields.updated"), value: "updated", align: "center" },
      ],
    };
  },
  computed: {
    filials() {
      return this.$store.getters["admin/filials"];
    },
  },
  methods: {
    edit(i) {
      this.d_edit = true;
      this.item = { ...i };
      this.currentIdx = this.filials.indexOf(i);
    },
    remove() {
      this.$store.dispatch("admin/DELETE_FILIAL", this.item).then(() => {
        this.d_edit = false;
      });
    },
    update() {
      if (this.item.idx) {
        this.$store
          .dispatch("admin/UPDATE_FILIAL", {
            item: this.item,
            index: this.currentIdx,
          })
          .then(() => {
            this.d_edit = false;
          });
      } else {
        const prev = this.items.find((e) => {
          return e.name == this.item.name;
        });
        if (prev) {
          this.filial_errors = this.$t("error.dublicate");
        } else {
          this.$store
            .dispatch("admin/INSERT_FILIAL", this.item)
            .then((response) => {
              if (response == 0) {
                this.filial_errors = this.$t("error.api");
              } else {
                this.d_edit = false;
              }
            });
        }
      }
    },
  },
  mounted() {
    this.$store.dispatch("admin/LOAD_FILIALS");
  },
};
</script>

<style scoped>
</style>